// angular
import { Component, effect, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { CommentBoxComponent } from '@app/core/components/comment-box/comment-box.component';
// service
import { CommentsService } from '@app/core/shared/services/comments.service';
// types & interfaces
import { ICommentData } from '@app/shared/interfaces/comment.interface';

@Component({
  selector: 'pwj-product-comments',
  standalone: true,
  imports: [CommentBoxComponent, TranslateModule],
  templateUrl: './product-comments.component.html',
  styleUrl: './product-comments.component.scss',
})
export class ProductCommentsComponent {
  public commentsData!: ICommentData[];

  // dependencies
  private readonly _commentsService = inject(CommentsService);

  constructor() {
    effect(() => {
      // get comments data
      this.commentsData = this._commentsService.commentsData();
    });
  }
}
